import { UpdateContactInfoAction } from './actions';
import { updateContactInfoInitialState, UpdateContactInfoState } from './state';

const reducer = (state: UpdateContactInfoState, action: UpdateContactInfoAction): UpdateContactInfoState => {
    switch (action.type) {
        case 'email':
            return {
                ...state,
                email: action.payload,
            };
        case 'mobile':
            return {
                ...state,
                mobile: action.payload,
            };
        case 'reset':
            return { ...updateContactInfoInitialState };
        default:
            return state;
    }
};

const updateContactInfoReducer = (
    state: UpdateContactInfoState,
    action: UpdateContactInfoAction,
): UpdateContactInfoState => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cUpdate contact info form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};

export default updateContactInfoReducer;
